import * as React from 'react';
import { memo } from 'react';
import { FavoriteToggle } from './components/FavoriteToggle';
import PDFButton from './components/PDFButton';
import { ShareButton } from './components/ShareButton';

interface IProps {
    cruiseNid: number;
    isShareVisible?: boolean;
}

const ActionsCruise = ({ cruiseNid, isShareVisible }: IProps) => {
    return (
        <div className="list-action">
            <ul className="list-group list-group-horizontal">
                {cruiseNid && (
                    <>
                        <li className="list-group-item">
                            <FavoriteToggle cruiseNid={cruiseNid} />
                        </li>
                        <li className="list-group-item">
                            <PDFButton cruiseNid={cruiseNid} />
                        </li>
                    </>
                )}
                {isShareVisible && (
                    <li className="list-group-item">
                        <ShareButton />
                    </li>
                )}
            </ul>
        </div>
    );
};
export default memo(ActionsCruise);
